{
  "commonHeader": {
    "toggleSidebar": "Visa eller dölj sidofältet",
    "cartLoading": "Varukorgen läses in",
    "cart": "Varukorg",
    "aicForAdmin": {
      "ariaLabel": "AI för administratörer"
    },
    "usersResults": "Användare, {0} resultat",
    "settingsResults": "Inställningar, {0} resultat",
    "navigationResults": "Navigering, {0} resultat",
    "learnMoreAbout": "Läs mer om {0}",
    "close": "Stäng",
    "products": "Produkter",
    "moreActions": "Fler åtgärder",
    "search": "Sök",
    "searchPlaceholderAll": "Sök efter användare, kontoinställningar eller navigering",
    "searchPlaceholderUsers": "Sök efter användare eller navigering",
    "searchPlaceholderSettings": "Sök efter kontoinställningar eller navigering",
    "searchPlaceholderNav": "Sök i navigering"
  },
  "footerCopyright": {
    "language": "Språk {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "Administratörsmeny"
    }
  },
  "shared": {
    "close": "Stäng",
    "sideMenu": {
      "personalAria": "Personlig meny",
      "adminAria": "Administratörsmeny",
      "mainNav": "Huvudnavigering",
      "submenu": "Undermeny",
      "pinnedSection": "{0} fäst",
      "sideMenuAria": "Sidomeny",
      "pinItem": "Fäst {0}",
      "unpinItem": "Ta bort fästning av {0}",
      "reorderGrabbed": "Ordna om {0}, greppad. Använd upp- och nedpilarna för att flytta, mellanslag eller Enter för att släppa, Escape för att avbryta.",
      "reorderIdle": "Ordna om {0}. Tryck på mellanslag eller Enter för att greppa.",
      "hintHandlePin": "Tryck på Tab för att komma åt draghandtaget och fästknappen",
      "hintHandle": "Tryck på Tab för att komma åt draghandtaget",
      "hintPin": "Tryck på Tab för att komma åt fästknappen",
      "upgradeToPro": "Uppgradera till Pro"
    },
    "item": "Objekt"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "Prova den nya upplevelsen"
    }
  },
  "aicGuide": {
    "common": {
      "close": "Stäng"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "Divisioner är nu tillgängliga"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "Hantera externa konton"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "Adressbok blir Kundkatalog"
    }
  },
  "feedback": {
    "itemLableForProductArea": "Produktområde",
    "itemLableForFeedback": "Feedback"
  }
}
